import { Injectable, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, shareReplay, startWith, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class ExtRouteService {
  private router = inject(Router);
  private previousUrl$ = new BehaviorSubject<string>('');

  constructor() {
    this.router.events
      .pipe(
        filter(evt => evt instanceof NavigationStart),
        tap(() => this.previousUrl$.next(this.router.url))
      )
      .subscribe();

    this.currentUrl$.subscribe();
  }

  readonly currentUrl$: Observable<string> = this.router.events.pipe(
    startWith(this.router.url),
    filter(event => event instanceof NavigationEnd),

    map(() => this.router.url),
    shareReplay(1)
  );
  url = toSignal(this.currentUrl$, { initialValue: this.router.url });

  public goBack(): void {
    this.router.navigateByUrl(this.previousUrl$.getValue());
  }
}
